import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { Subscription } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class KendoMessageService extends MessageService implements OnDestroy {
   private subLanguageChanged: Subscription;

   constructor(private translateService: TranslateService) {
      super();
   }

   public initialize() {
      // update Kendo texts once TranslateService completed a language change
      this.subLanguageChanged = this.translateService.onLangChange.subscribe(() => super.notify());
   }

   public get(key: string): string {
      // skip lookup when using English (fall back to built-in texts)
      if (this.translateService.currentLang === 'en') {
         return undefined;
      }

      const translation = this.translateService.instant(key);
      // return undefined if no translation was found, to have Kendo fall back to their built-in texts (English)
      return translation === key ? undefined : translation;
   }

   ngOnDestroy(): void {
      this.subLanguageChanged?.unsubscribe();
   }
}
